'use strict';

const { BID_IMG_JS_CLASS, BID_INTERSECTION_INDICATOR_JS_CLASS } = require('../adformConstants');
const adformConstants = require('../adformConstants');
const { getAdformTranslation } = require('../common/jsAdformTranslations');

/**
 * Generates html (link with img) based on bid data.
 * @param {Object} data - bid data (price, url, img...)
 * @param {boolean} isImgLoadingLazy - if img should be lazy loaded
 * @return {string} html
 */
function generateBannerHtml(data, isImgLoadingLazy) {
    if (!data
        || !data.price
        || !data.vanityURL
        || !data.desktopImgURL
        || ![true, false].includes(isImgLoadingLazy)
    ) {
        return '';
    }

    let img = `<img class="img-fluid ${BID_IMG_JS_CLASS}" 
                    src="${data.mobileImgURL || data.desktopImgURL}" 
                    loading="${isImgLoadingLazy ? 'lazy' : 'eager'}" 
                    fetchpriority="${isImgLoadingLazy ? 'auto' : 'high'}" 
                    alt="${getAdformTranslation('banner.alt')}"/>`;

    if (data.mobileImgURL) {
        img = `<picture>
                    <source srcset="${data.desktopImgURL}" media="(min-width: 768px)">
                    ${img}
                </picture>`;
    }

    return `<a href="${data.vanityURL}" class="position-relative">
                ${img}
                <div class="position-absolute top-0 bottom-0 right-5p w-10p ${BID_INTERSECTION_INDICATOR_JS_CLASS}"></div>
            </a>`;
}

/**
 * Generates html (link with img) based on bid data.
 * @param {Object} data - bid data (price, url, img...)
 * @param {string} productTilesHtml - product tiles html
 * @param {string} bannerPosition - if "featured block" banner should be "left" or "right"
 * @param {string} dataTileContainerId - used for data layer tracking ("view_item_list" event)
 * @return {string} html
 */
function generateFeaturedBlockHtml(data, productTilesHtml, bannerPosition, dataTileContainerId) {
    if (!data
        || !data.price
        || !data.vanityURL
        || !data.desktopImgURL
        || !data.mobileImgURL
        || !productTilesHtml
        || !dataTileContainerId
        || !['left', 'right'].includes(bannerPosition)
    ) {
        return '';
    }

    const bannerImg = `
                <img src="${data.mobileImgURL}" 
                    class="img-fluid ${adformConstants.BID_INTERSECTION_INDICATOR_JS_CLASS} ${BID_IMG_JS_CLASS}" 
                    loading="lazy" 
                    width="522" 
                    height="522"
                    alt="${getAdformTranslation('banner.alt')}"
                />`;

    return `
        <div class="bg-position-center bg-size-cover" style="background-image: url(${data.desktopImgURL})" data-tile-container-id="${dataTileContainerId}">
            <div class="container">
                <div class="row py-8">
                    <div class="col-lg-8 order-1 d-flex align-items-center ${bannerPosition === 'right' ? 'order-lg-0' : ''}">
                        <div class="row flex-1 row-cols-2 row-cols-lg-4 g-5">${productTilesHtml}</div>
                    </div>
                    <div class="col-lg-4 d-flex align-items-center justify-content-center position-relative mb-6 mb-lg-0">
                        <div class="w-75 text-center">
                            <a href="${data.vanityURL}" class="d-block mb-4">
                                ${bannerImg}    
                            </a>
                            <a class="btn btn-outline-primary" href="${data.vanityURL}">${getAdformTranslation('featuredblock.button')}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>`.trim();
}

module.exports = {
    generateBannerHtml: generateBannerHtml,
    generateFeaturedBlockHtml: generateFeaturedBlockHtml
};
